import { render, staticRenderFns } from "./VueGoodshare.vue?vue&type=template&id=edb5ac38&"
import script from "./VueGoodshare.vue?vue&type=script&lang=js&"
export * from "./VueGoodshare.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports